module.exports = __webpack_public_path__ + "static/media/article-icon-inactive.1c8f3896.svg";